export const INITIAL_SLOPE = 3
export const FAR_FIELD = 24
export const CURVATURE_BAND_INNER = 2
export const CURVATURE_BAND_OUTER = 4
export const HEAT_BAND_START = 0.2
export const MAX_TEMPERATURE = 1.5
export const LIQUID_BAND = 0.1
export const MELT_BAND = 0.2
export const SHADE_WET_BAND = 0.15
export const SURFACE_BAND_OUTER = 0.5
export const GRAVITY_BAND = 2
export const TENSION_BAND = 1.5
export const FREEZE_ONSET = 0.25
export const PAPANASTASIOU_EXPONENT = 50
export const AIR_VELOCITY_DECAY = 0.9
export const ONSET_OCTAVES = 3
export const COLUMN_OCTAVES = 2
export const COLUMN_FREQUENCY = 2
export const SEED_DECORRELATION = 0.37
export const LAYER_SEED_STRIDE = 17.3
export const NORMAL_FLATNESS = 0.25
export const HELD_BAND_INNER = 0.9
export const HELD_BAND_OUTER = 2
export const STRETCH_ALPHA_INNER = 0.005
export const STRETCH_ALPHA_OUTER = 0.05
export const THICKNESS_PER_RIM = 2
export const COVERAGE_CUTOFF = 0.003
export const AMBIENT = 0.8
export const SPECULAR_POWER_MIN = 10
export const SPECULAR_POWER_MAX = 260
export const FRESNEL_POWER = 3
export const SKY_FLOOR = 0.2
export const REFLECTION_STRENGTH = 0.7
export const TRANSLUCENCY_STRENGTH = 0.6
export const RIM_MINIMUM = 2
export const GRAVITY_PER_HEIGHT = 0.15
export const MIN_LIQUID_VISCOSITY = 0.05
export const VISCOSITY_PER_HEIGHT = 0.12
export const YIELD_PER_HEIGHT = 0.3
export const TENSION_STABILITY = 0.4
export const REINIT_PASSES = 2
export const INITIAL_REINIT_PASSES = 8
export const SMOOTH_PASSES = 4
export const COARSEST_LEVEL = 8
export const MAX_LEVELS = 6
export const FLOOR_ROWS = 2
export const WALL_DISTANCE = 1
export const CFL_LIMIT = 0.5
export const FLOOR_SOFT = 10
